import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.55 15c0-6.904 5.595-12.5 12.5-12.5 6.902 0 12.5 5.596 12.5 12.5s-5.598 12.5-12.5 12.5c-6.905 0-12.5-5.596-12.5-12.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16.65 9.583h-1.155c-2.117 0-3.231 1.072-3.231 2.653 0 1.788.77 2.625 2.351 3.699l1.306.88-3.753 5.609H9.363l3.368-5.018c-1.937-1.389-3.025-2.737-3.025-5.018 0-2.86 1.994-4.813 5.775-4.813h3.754V22.41H16.65V9.583Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "yandex"}) } }